export enum ReferenceType {

  Claim = 1,
  PortalUser = 2,
  InsuranceCompany = 3,
  CarRental = 4,
  WorkshopNetwork = 5,
  Workshop = 6,
  Document = 8,
  GeneratedDocument = 10,
  Invoice = 11,
  ProofDocument = 12,
  Inspection = 13,
  CostEstimation = 14,
  ClaimActivity = 15,
  CostInvoice = 17,
  SearchFilter = 18,
  PartsOrder = 19,
  Employee = 20,
  PortalMessage = 21,
  StageCommand = 22,
  Comment = 23,
  InvoiceSubject = 24,
  InspectionCard = 25,
  Repair = 26,
  RepairAssembly = 27,
  CarRent = 28,
  CostReportData = 29,
  PeriodicalValue = 30,
  ExternalIdentifier = 31,
  PortalMessageThread = 32,
  InvoiceSalesRegistry = 33,
  PortalMessageRecipient = 34,
  Entity = 35,
  ClaimOperatingCompany = 36,
  IndividualCustomer = 37,
  PartsSupplier = 38,
  IndividualSupplier = 39,
  InvoiceDuplicate = 40,
  InvoiceCorrection = 41,
  InvoicePreSale = 42,
  PaymentInvoice = 43,
  EmployeeCompany = 44,
  PaymentInvoiceDeclaration = 45,
  CarReceptionData = 46,
  CarReceptionDataElement = 47,
  CarRentAgreement = 48,
  CarRentAgreementElement = 49,
  CarRentalFleetCarElement = 50,
  CarRentalFleetCar = 51,
  Dealer = 52,
  BusinessTrip = 53,
  CostInvoiceForClassification = 54,
  InvoiceReconcilation = 55,
  CalculatorClientCompany = 56
}


